module.exports = __webpack_public_path__ + "static/media/mail-home-ice-blue.8968b3fc.svg";